export default Object.freeze({
  helvetica: 'Helvetica',
  times: 'Times',
  courier: 'Courier',
})



// WEBPACK FOOTER //
// ./src/models/FontOption.js